module.exports = __webpack_public_path__ + "static/anana-vestige-home-sitting-on-mountain-8b34975d66bf91eb91963bff596fd951.png";